import { render, staticRenderFns } from "./descIconSvg.vue?vue&type=template&id=d84bdc28&"
import script from "./descIconSvg.vue?vue&type=script&lang=js&"
export * from "./descIconSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports